import MuiCheckbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { SxProps } from '@mui/material/styles'
import FieldLabel from '@shared/forms/FieldLabel'
import { useT } from '@transifex/react'
import { ReactNode } from 'react'

export const checkBoxLabelStyle: SxProps = {
  mt: 0,
  mb: 0,
  ml: 1,
  cursor: 'pointer !important',
}
type CheckboxProps = {
  label: ReactNode
  elementId: string
  onChange: (event: React.SyntheticEvent) => void
  isDisabled?: boolean
  isChecked?: boolean
  indeterminate?: boolean
  icon?: ReactNode
  checkBoxStyle?: SxProps
}

const Checkbox: React.FC<CheckboxProps> = ({
  elementId,
  isDisabled,
  label,
  onChange,
  isChecked,
  indeterminate = false,
  icon,
  checkBoxStyle,
}) => {
  const t = useT()

  return (
    <FormControlLabel
      onClick={onChange}
      sx={{ width: 'fit-content' }}
      control={
        <MuiCheckbox
          checked={isChecked}
          onChange={onChange}
          indeterminate={indeterminate}
          disabled={isDisabled}
          id={elementId}
          aria-label={t('Checkbox')}
          icon={icon}
          sx={checkBoxStyle}
        />
      }
      label={<FieldLabel labelStyle={checkBoxLabelStyle}>{label}</FieldLabel>}
      disabled={isDisabled}
      id="checkboxLabel"
      aria-label={t('Checkbox label')}
    />
  )
}

export default Checkbox
